import React from "react";
import { connect } from "react-redux";
import Login from "./authentication/Login";
import News from "./News";
import Grid from "@material-ui/core/Grid";
import Statistic from "./Statistic";
import Storybook from "./Storybook";
import { withTranslation } from "react-i18next"; // Import withTranslation

const Home = (props) => {
    const { t } = props; // Destructure t from props

    return (
        <Grid container spacing={16}>
            <Grid item xs={12} sm={4}>
                <News />
            </Grid>
            <Grid item xs={12} sm={5}>
                <Storybook />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Grid container spacing={16}>
                    <Grid item xs={12}>
                        <Login />
                    </Grid>
                    <Grid item xs={12}>
                        <a href="https://www.unwe.bg">
                            <img
                                src="https://www.unwe.bg/Content/100years/100yearsunwe.PNG"
                                alt={t("unwe100YearsAlt")} /* Translate "100 ������ ����" */
                                width="100%"
                            />
                        </a>
                        <a href="https://www.idealcandidate.bg">
                            <img
                                src="/img/ideal.jpg"
                                alt={t("idealCandidateAlt")} /* Translate "��������� ��������" */
                                width="100%"
                            />
                        </a>
                    </Grid>
                    <Grid item xs={12}>
                        <Statistic />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

//Home.propTypes = {
//    t: PropTypes.func.isRequired, // Add t to propTypes
//};

export default withTranslation()(connect()(Home)); // Wrap the component with withTranslation

//import React from 'react';
//import { connect } from 'react-redux';
//import Login from './authentication/Login';
//import News from './News';
//import Grid from '@material-ui/core/Grid';
//import Statistic from './Statistic';
//import Storybook from './Storybook';

//const Home = props => (
//    <Grid container spacing={16}>
//        <Grid item xs={12} sm={4}>
//            <News />
//        </Grid>
//        <Grid item xs={12} sm={5}>
//            <Storybook />
//        </Grid>
//        <Grid item xs={12} sm={3}>
//            <Grid container spacing={16}>
//                <Grid item xs={12}>
//                    <Login />
//                </Grid>
//                <Grid item xs={12}>
//                    <a href="https://www.unwe.bg"><img src="https://www.unwe.bg/Content/100years/100yearsunwe.PNG" alt="100 ������ ����" width="100%" /></a>
//                    <a href="https://www.idealcandidate.bg"><img src="/img/ideal.jpg" alt="��������� ��������" width="100%" /></a>
//                </Grid>
//                <Grid item xs={12}>
//                    <Statistic />
//                </Grid>
//            </Grid>
//        </Grid>
//    </Grid>
//);

//export default connect()(Home);
